/* @build 2026-07-10.2 */
/* ============================================================
   KineRelief Cart Drawer — UpCart-style behaviour
   Slide-out · inline AJAX (no reload) · straight to checkout.
   Intercepts Dawn's add-to-cart forms + the header cart icon.
   ============================================================ */
/* ---------- DEAD-END SENTINEL (standalone — must survive anything) ----------
   Ported from kh 2026-08-04 after a Kaching Bundles app update silently killed
   Konah Home's add-to-cart -> drawer -> checkout path for ~15h (app JS changes
   with no theme push and can swallow click/submit events before the drawer
   sees them). Guarantee: after any tap on something clickable, if the cart
   count GREW but no drawer is visible ~1.5-4s later, send the buyer to /cart.
   Standalone IIFE, window-capture pointerdown, once per pageview, never on
   /cart or /checkout pages. See konah-home/kh-cart-drawer.js for full spec. */
(function () {
  'use strict';
  var busy = false, done = false;
  function count(cb) {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cb(c && typeof c.item_count === 'number' ? c.item_count : null); })
        .catch(function () { cb(null); });
    } catch (e) { cb(null); }
  }
  function drawerVisible() {
    var d = document.getElementById('krcdDrawer');
    return !!(d && !d.hidden && d.classList.contains('is-open'));
  }
  function onCartOrCheckout() {
    var p = location.pathname;
    return p.indexOf('/cart') === 0 || p.indexOf('checkout') !== -1;
  }
  window.addEventListener('pointerdown', function (e) {
    try {
      if (busy || done || onCartOrCheckout()) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('button, [role="button"], [type="submit"], [name="add"], input, a, form, [class*="kaching"], [class*="bundle"], [class*="atc"], [class*="add-to-cart"]')) return;
      busy = true;
      var baseline = null;
      count(function (n) { baseline = n; });
      [1500, 2600, 3900].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (done || drawerVisible() || onCartOrCheckout()) return;
            count(function (n) {
              if (done || drawerVisible() || onCartOrCheckout()) return;
              if (baseline !== null && n !== null && n > baseline) {
                done = true;
                window.location.href = '/cart';
              }
            });
          } catch (err) {}
        }, ms);
      });
      setTimeout(function () { busy = false; }, 4600);
    } catch (err) {}
  }, true);
})();

(function () {
  'use strict';

  var overlay = document.getElementById('krcdOverlay');
  var drawer  = document.getElementById('krcdDrawer');
  if (!drawer || !overlay) return;

  var closeBtn    = document.getElementById('krcdClose');
  var itemsEl     = document.getElementById('krcdItems');
  var countEl     = document.getElementById('krcdCount');
  var footerEl    = document.getElementById('krcdFooter');
  var lowStockEl  = document.getElementById('krcdLowStock');
  var lowTextEl   = document.getElementById('krcdLowStockText');
  var checkoutTotalEl = document.getElementById('krcdCheckoutTotal');
  var rewardMsgEl = document.getElementById('krcdRewardMsg');
  var barFillEl   = document.getElementById('krcdBarFill');

  var CFG    = window.krcdConfig || {};
  var THRESH = CFG.threshold || 4000;
  var LOWPCT = (CFG.lowPct != null) ? CFG.lowPct : 12;

  /* ---------- speed state (optimistic UI) ----------
     pendingQty holds quantities the user has tapped to but the server hasn't
     confirmed yet; render() must never clobber those rows. lastKeysSig lets
     render() skip full innerHTML rebuilds (and image reloads) when the set of
     cart lines is unchanged. */
  var pendingQty = {}, qtyTimers = {};
  var lastKeysSig = null;
  var lastCount = 0;   /* last item_count the drawer has rendered — pre-add baseline for the Kaching watcher */

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amt = (cents || 0) / 100.0;
    function commas(s) { return s.replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      if (key === 'amount_no_decimals') return commas(Math.round(amt).toFixed(0) + '.').slice(0, -1);
      if (key === 'amount_with_comma_separator') return commas(amt.toFixed(2)).replace('.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return commas(Math.round(amt).toFixed(0));
      return commas(amt.toFixed(2));
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    overlay.hidden = false; drawer.hidden = false;
    void drawer.offsetWidth; /* reflow so transition runs */
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  closeBtn && closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- render ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var TRASH = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';

  function itemHTML(it) {
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    if (img) img = img.replace(/(\.[a-zA-Z]+)(\?|$)/, '_200x200$1$2');
    var variant = (it.variant_title && it.variant_title !== 'Default Title')
      ? '<div class="krcd-item-variant">' + esc(it.variant_title) + '</div>' : '';
    var cmpUnit = it.original_price && it.original_price > it.final_price ? it.original_price : 0;
    var cmpLine = cmpUnit ? cmpUnit * it.quantity : 0;
    var compare = (cmpLine > it.final_line_price)
      ? '<span class="krcd-price-compare">' + formatMoney(cmpLine) + '</span>' : '';
    return '' +
      '<div class="krcd-item" data-key="' + esc(it.key) + '">' +
        '<a class="krcd-item-img" href="' + esc(it.url) + '">' +
          (img ? '<img src="' + esc(img) + '" width="88" height="88" loading="lazy" alt="' + esc(it.product_title) + '">' : '') +
        '</a>' +
        '<div class="krcd-item-main">' +
          '<div class="krcd-item-titlerow">' +
            '<span class="krcd-item-title">' + esc(it.product_title) + '</span>' +
            '<button class="krcd-remove" data-key="' + esc(it.key) + '" type="button" aria-label="Remove">' + TRASH + '</button>' +
          '</div>' +
          variant +
          '<div class="krcd-item-bottom">' +
            '<div class="krcd-qty">' +
              '<button type="button" data-action="decrease" data-key="' + esc(it.key) + '" aria-label="Decrease quantity">−</button>' +
              '<span class="krcd-qty-val">' + it.quantity + '</span>' +
              '<button type="button" data-action="increase" data-key="' + esc(it.key) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="krcd-item-price">' + compare +
              '<span class="krcd-price-final">' + formatMoney(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function syncHeaderBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        icon.appendChild(bubble);
      }
      var span = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (span) span.textContent = count < 100 ? count : '';
    } else if (bubble) {
      bubble.remove();
    }
  }

  /* Fast path: update qty/prices on existing rows without rebuilding the DOM
     (keeps <img> nodes alive — no reload/flicker). Skips rows with unconfirmed
     optimistic quantities so the user's taps are never visually reverted. */
  function renderInPlace(cart) {
    cart.items.forEach(function (it) {
      var row = itemsEl.querySelector('.krcd-item[data-key="' + it.key + '"]');
      if (!row) return;
      if (!pendingQty.hasOwnProperty(it.key)) {
        var v = row.querySelector('.krcd-qty-val');
        if (v) v.textContent = it.quantity;
        row.classList.remove('krcd-item--removing');
      }
      var pf = row.querySelector('.krcd-price-final');
      if (pf) pf.textContent = formatMoney(it.final_line_price);
      var cmpUnit = it.original_price && it.original_price > it.final_price ? it.original_price : 0;
      var cmpLine = cmpUnit ? cmpUnit * it.quantity : 0;
      var pc = row.querySelector('.krcd-price-compare');
      if (cmpLine > it.final_line_price) {
        if (pc) { pc.textContent = formatMoney(cmpLine); }
        else {
          var pr = row.querySelector('.krcd-item-price');
          if (pr) pr.insertAdjacentHTML('afterbegin', '<span class="krcd-price-compare">' + formatMoney(cmpLine) + '</span>');
        }
      } else if (pc) { pc.remove(); }
    });
  }

  function render(cart) {
    lastCount = cart.item_count;
    if (countEl) countEl.textContent = cart.item_count;
    syncHeaderBubble(cart.item_count);

    /* reward bar */
    if (cart.total_price >= THRESH) {
      rewardMsgEl.innerHTML = 'Congrats — you’ve unlocked <b>free shipping!</b>';
    } else {
      rewardMsgEl.innerHTML = 'You’re <b>' + formatMoney(THRESH - cart.total_price) + '</b> away from free shipping!';
    }
    var pct = Math.min(100, Math.round((cart.total_price * 100) / THRESH));
    if (barFillEl) barFillEl.style.width = pct + '%';

    /* items */
    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="krcd-empty" id="krcdEmpty">' +
          '<svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="/collections/all">Continue shopping</a>' +
        '</div>';
      footerEl && footerEl.classList.add('is-hidden');
      lowStockEl && lowStockEl.classList.add('is-hidden');
      lastKeysSig = null;
    } else {
      var keysSig = cart.items.map(function (i) { return i.key; }).join('|');
      if (keysSig === lastKeysSig && itemsEl.querySelector('.krcd-item')) {
        renderInPlace(cart);
      } else {
        itemsEl.innerHTML = cart.items.map(itemHTML).join('');
        lastKeysSig = keysSig;
      }
      footerEl && footerEl.classList.remove('is-hidden');
      lowStockEl && lowStockEl.classList.remove('is-hidden');
      if (lowTextEl) {
        lowTextEl.textContent = cart.item_count === 1
          ? 'One item in your cart is low in stock.'
          : 'Some items in your cart are low in stock.';
      }
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  /* ---------- cart API ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh() { return fetchCart().then(render); }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function addItem(variantId, qty, props) {
    var item = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (props) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(open);
  }
  function addFormData(fd) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(open);
  }

  window.krCartDrawer = { open: open, close: close, addItem: addItem, refresh: refresh };

  /* ---------- Kaching Bundles add-watcher ----------
     The Duo/Trio bundle bars hijack the ATC click and POST /cart/add themselves,
     so no form-submit fires and the capture-phase interceptor never opens the
     drawer on bundle adds. A window.fetch net does NOT work: Kaching loads in
     <head> and holds an early fetch reference, bypassing any later wrapper.
     Instead: after any add-to-cart click, run a few bounded cart-count checks and
     open the drawer if the count grew past the last count the drawer rendered.
     Transport- and load-order-agnostic. NOT a continuous poll (a handful of
     checks per click, stops on first detection) — so it does not trip Shopify's
     bot-signal checkout captcha. Added 2026-07-21. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[name="add"], form[action*="/cart/add"] [type="submit"], .kaching-bundles, [class*="kaching-bundles"]')) return;
    var baseline = lastCount;   /* synchronous, pre-add — no fetch race */
    [500, 1100, 1800, 2600].forEach(function (ms) {
      setTimeout(function () {
        if (drawer.classList.contains('is-open')) return;
        fetchCart().then(function (c) {
          if (c.item_count > baseline && !drawer.classList.contains('is-open')) { render(c); open(); }
        }).catch(function () {});
      }, ms);
    });
  }, true);

  /* ---------- delegated qty / remove (OPTIMISTIC — instant UI, debounced sync) ----------
     The number bumps at tap time (0ms feedback); one /cart/change.js call with
     the final quantity fires 300ms after the last tap. Rapid taps = one request. */
  function queueQty(key, qty) {
    pendingQty[key] = qty;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      var q = pendingQty[key];
      delete pendingQty[key]; delete qtyTimers[key];
      changeQty(key, q);
    }, 300);
  }
  itemsEl.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.krcd-qty button');
    if (qtyBtn) {
      var row = qtyBtn.closest('.krcd-item');
      var key = qtyBtn.getAttribute('data-key');
      var valEl = row.querySelector('.krcd-qty-val');
      var cur = pendingQty.hasOwnProperty(key) ? pendingQty[key] : (parseInt(valEl.textContent, 10) || 0);
      var next = qtyBtn.getAttribute('data-action') === 'increase' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      valEl.textContent = next;
      row.classList.toggle('krcd-item--removing', next === 0);
      queueQty(key, next);
      return;
    }
    var rm = e.target.closest('.krcd-remove');
    if (rm) {
      var k = rm.getAttribute('data-key');
      var r2 = rm.closest('.krcd-item');
      if (r2) r2.classList.add('krcd-item--removing');
      queueQty(k, 0);
    }
  });

  /* ---------- checkout: straight to checkout, skip cart page ---------- */
  var checkoutBtn = document.getElementById('krcdCheckout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      checkoutBtn.style.opacity = '.7';
      window.location.href = '/checkout';
    });
  }

  /* ---------- intercept ADD-TO-CART forms (capture phase → beats Dawn) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    var submitBtn = form.querySelector('[type="submit"], [name="add"]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
    /* perceived speed: open the drawer immediately with a subtle loading state;
       the new item pops in when the add completes */
    open();
    drawer.classList.add('is-adding');
    addFormData(new FormData(form))
      .catch(function () {})
      .then(function () {
        drawer.classList.remove('is-adding');
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
      });
  }, true);

  /* ---------- intercept every cart trigger → open drawer (never /cart) ---------- */
  function bindCartTriggers() {
    var sels = '#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], [data-kr-cart-open]';
    document.querySelectorAll(sels).forEach(function (el) {
      if (el.__krBound) return; el.__krBound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        refresh(); open();
      });
    });
  }
  bindCartTriggers();
  document.addEventListener('DOMContentLoaded', bindCartTriggers);
})();
